// Static data used across all delivery phases.

export const getStopLabel = (index) => String(index + 1);

export const MAX_STOPS = 5;

// Rough per-stop delivery estimate shown in the route summary, until real
// per-leg ETAs are wired up from telemetry.
export const STOP_ETA_MINUTES = 2;

export const STATUS_MESSAGES = [
  "Approaching destination",
  "Turning toward destination",
  "Slowing down",
  "Locating delivery point",
  "Preparing to stop",
  "Final approach",
];
